// extracted by mini-css-extract-plugin
export default {"iconBackground":"life-line-power_iconBackground__7FazE","dashContainer":"life-line-power_dashContainer__qYib+"};